import { Features, useFeature } from '@news-mono/web-common'
import React from 'react'

export interface FeatureToggleProps {
    feature: Features
    on: () => React.ReactElement<any> | null
    off?: () => React.ReactElement<any> | null
}

export const FeatureToggle: React.FC<FeatureToggleProps> = ({
    feature,
    on,
    off,
}) => {
    const isEnabled = useFeature(feature)

    if (isEnabled) {
        return on()
    }

    if (off) {
        return off()
    }

    return null
}
FeatureToggle.displayName = 'FeatureToggle'
